module.exports = __webpack_public_path__ + "assets/img/w_d_i_6.0fe6cbb8.jpg";